import { healthClient, handleRequest } from '@/shared/api';
import type { SystemHealthResponse } from '@/entities/system';

export const checkSystemHealth = async () => {
  const request = () => healthClient.get('/system/health');
  const response = await handleRequest<SystemHealthResponse>(request);
  return response.data;
};
